<template>
  <div>
    <div :class="videoPage.divClass">
      <div v-for="(item, order) in videoPage.value" :key="order">
        <Media
          :kind="'video'"
          :isMuted="false"
          :src="item.link"
          :autoplay="false"
          :controls="true"
          :loop="false"
          @pause="handle"
          :ref="'video_player'"
          :width="videoPage.style.height"
          :hight="videoPage.style.width"
          :class="videoPage.style.class"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
export default {
  data() {
    return {};
  },
  methods: {},
  props: {
    videoPage: {
      type: Object
    }
  },
  components: {
    Media
  }
};
</script>

<style lang="scss"></style>
